/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { isFunction } from "utils/APIUtils";
import { featureLifecycleHookController } from "./controller/featureLifecycleHookController";
import { featureLifecyleHooks } from "constants/enums";

export const getfeatureLifecycleHookApis = () => {
  function beforePrint(callback) {
    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_PRINT, callback);
    }
  }
  function beforeRotateView(callback) {
    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_ROTATE_VIEW, callback);
    }
  }
  function beforeDownload(callback) {
    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_DOWNLOAD, callback);
    }
  }
  function afterPrint(callback) {
    // wrap the callback in promise for after hooks
    const callbackWrapper = data =>
      new Promise(resolve => {
        callback(data);
        resolve();
      });

    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.AFTER_PRINT, callbackWrapper);
    }
  }
  function afterDownload(callback) {
    // wrap the callback in promise for after hooks
    const callbackWrapper = data =>
      new Promise(resolve => {
        callback(data);
        resolve();
      });

    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.AFTER_DOWNLOAD, callbackWrapper);
    }
  }

  function beforeOrganizePages(callback) {
    if (isFunction(callback)) {
      featureLifecycleHookController.on(featureLifecyleHooks.BEFORE_ORGANIZE_PAGES, callback);
    }
  }

  function unSubscribeBeforeOrganizePages(callback) {
    if (isFunction(callback)) {
      featureLifecycleHookController.unregister(featureLifecyleHooks.BEFORE_ORGANIZE_PAGES, callback);
    }
  }

  return {
    beforePrint,
    beforeRotateView,
    beforeDownload,
    afterPrint,
    afterDownload,
    beforeOrganizePages,
    unSubscribeBeforeOrganizePages
  };
};
